import { Box, CircularProgress } from '@mui/material';
import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { initAuth } from '../store/slices/auth-slice';

interface AuthGateProps {
  children: React.ReactNode;
}

export function AuthGate({ children }: AuthGateProps) {
  const dispatch = useAppDispatch();
  const status = useAppSelector((state) => state.auth.status);
  const location = useLocation();
  const isSharedPage = location.pathname.startsWith('/shared-chat/');

  useEffect(() => {
    if (!isSharedPage && status === 'idle') {
      void dispatch(initAuth());
    }
  }, [dispatch, isSharedPage, status]);

  if (isSharedPage) {
    return (
      <Box sx={{ height: '100%', width: '100%' }}>
        {children}
      </Box>
    );
  }

  if (status === 'idle' || status === 'loading') {
    return (
      <Box
        sx={{
          width: '100%',
          minHeight: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  const isLoginPage = location.pathname === '/login';

  if (status === 'unauthenticated') {
    if (!isLoginPage) {
      return (
        <Navigate
          to={{ pathname: '/login', search: location.search }}
          replace
        />
      );
    }

    return <>{children}</>;
  }

  if (isLoginPage) {
    return (
      <Navigate to={{ pathname: '/chats', search: location.search }} replace />
    );
  }

  return (
    <Box sx={{ height: '100%', width: '100%' }}>
      {children}
    </Box>
  );
}
